import React, { PureComponent } from "react";
import Grid from "@material-ui/core/Grid";
import * as R from "ramda";
import Divider from "@material-ui/core/Divider/Divider";
import { dropRecordingExtension } from "../MainContainer";
import { upCase } from "../../lib/utils";

const mapIndexed = R.addIndex(R.map);

const preserveTail = values => [R.head(values), R.pipe(R.tail, R.map(upCase), R.join(" "), R.replace("Modified", "- Modified"))(values)];

const formatRecordingName = recordingName =>
  R.pipe(
    R.replace("p_c", "P&C"),
    dropRecordingExtension,
    R.split("_"),
    preserveTail,
    R.map(upCase),
    R.join(" - ")
  )(recordingName);

const getRecordingsInState = recordingState =>
  R.pipe(R.propOr([], recordingState), R.map(formatRecordingName));

const notEmpty = R.complement(R.isEmpty);

export default class RecordingStatus extends PureComponent {
  renderRecordings = (status, recordings) => {
    return (
      <Grid container direction="row">
        <Grid item xs={12}>
          <h2 style={{ textAlign: "center", marginBottom: 8, marginTop: 8 }}>{status}</h2>
        </Grid>
        <Grid item xs={12}>
          {notEmpty(recordings) ? (
            <ul>{mapIndexed(this.renderRecording, recordings)}</ul>
          ) : (
            <p style={{ marginLeft: 20 }}>No Recordings</p>
          )}
        </Grid>
        <Grid item xs={12}>
          <Divider />
        </Grid>
      </Grid>
    );
  };

  renderRecording = (recordingName, index) => <li key={index}>{recordingName}</li>;

  render() {
    const { agentRecordings } = this.props;
    return (
      <Grid container spacing={16}>
        <Grid item xs={3} />
        <Grid item xs={6}>
          {this.renderRecordings("Missing", getRecordingsInState("missing")(agentRecordings))}
          {this.renderRecordings(
            "Under Review",
            getRecordingsInState("under_review")(agentRecordings)
          )}
          {this.renderRecordings("In Use", getRecordingsInState("in_use")(agentRecordings))}
        </Grid>
        <Grid item xs={3} />
      </Grid>
    );
  }
}
